import styled from 'styled-components';

export const MgpGaugeChartContainer = styled.div`
  height: 200px;
`;

export const MgpGaugeChartLabel = styled.div<{ color: string }>`
  font-size: 18px;
  color: ${({ color }) => color};
  font-weight: 600;
`;
